export const formInitialValues = (data) => ({
  kodeSubKelompok: data?.kode_sub_kelompok_anggaran ?? "",
  keterangan: data?.keterangan ?? "",
  idSubKelompok: data?.id_sub_kelompok_anggaran ?? undefined,
  namaSubKelompok: data?.nama_sub_kelompok_anggaran ?? "",
  idKelompok: data?.id_kelompok_anggaran ?? null,
  namaKelompok: data?.nama_kelompok_anggaran ?? "",
});
